import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeCustomerGroupSettingsRoot } from './customerGroupRoutes'
import { routePhoneTypeSettingsRoot } from './phoneTypeRoutes'
import { routeRatingSettingsRoot } from './ratingRoutes'
import { routeRoleSettingsHome, routeRoleSettingsRoot } from './roleRoutes'
import { routeSalutationSettingsRoot } from './salutationRoutes'
import { routeSupplierGroupSettingsRoot } from './supplierGroupRoutes'
import { routeWeblinkTypeSettingsRoot } from './weblinkTypeRoutes'

const routeBRMSettingsHome: RouteRecordRaw = routeRoleSettingsHome

const routeBRMSettingsRoot: RouteRecordRaw = {
  children: [
    routeBRMSettingsHome,
    routeCustomerGroupSettingsRoot,
    routePhoneTypeSettingsRoot,
    routeRatingSettingsRoot,
    routeRoleSettingsRoot,
    routeSalutationSettingsRoot,
    routeSupplierGroupSettingsRoot,
    routeWeblinkTypeSettingsRoot,
  ],
  path: 'brm',
}

const redirectBRMSettings: RedirectRouteRelative = {
  name: routeBRMSettingsHome.name,
}

export { redirectBRMSettings, routeBRMSettingsHome, routeBRMSettingsRoot }
